import React from 'react'

import { Button } from '@refera/ui-web'

// import useRolePermission from '_/hooks/use-role-permission'
// import { useLocation } from '@reach/router'
// import { useBudgetForm } from '_/views/budget-view-v2/hooks/use-budget-form'

export default function SaveModelButton() {
  // const { isTradesman } = useRolePermission()
  // const { pathname } = useLocation()
  // const { isEditing } = useBudgetForm()
  // const isCreating = pathname.includes('/novo')

  // while is not defined
  const showButton = false
  // const showButton = !isEditing && isTradesman && !isCreating

  function handleClick() {}

  if (!showButton) return null

  return (
    <Button onClick={handleClick} color="primary" variant="secondary">
      Salvar modelo
    </Button>
  )
}
